var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-column-element',_vm._g(_vm._b({attrs:{"align":this.$attrs.align || 'right'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('number',{attrs:{"number":_vm._f("get")(row,_vm.$attrs.prop),"currencySymbol":_vm.currencySymbol}})]}}])},'table-column-element',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9029a2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-number.vue
// module id = null
// module chunks = 